export const path = "M15.5 5H11l5 7-5 7h4.5l5-7z M8.5 5H4l5 7-5 7h4.5l5-7z"
